import { render } from "./Distribution.vue?vue&type=template&id=47596429"
import script from "./Distribution.vue?vue&type=script&lang=js"
export * from "./Distribution.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__